/* ==========================================================================
   G Studs - JavaScript personalizado
   --------------------------------------------------------------------------
   Migrado do bloco "custom_liquid" do rodape em 2026-08-04.
   A partir de agora edita-se AQUI (Assets > gs-custom.js), nunca no rodape.
   Carregado com defer em layout/theme.liquid.

   Cada modulo esta isolado e so corre na pagina certa. O padrao e sempre o
   mesmo: uma funcao que devolve true quando ja aplicou, chamada num intervalo
   que desiste ao fim de N tentativas (o tema monta partes do DOM tarde).
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Utilitarios
     --------------------------------------------------------------- */
  var body = document.body;
  var TEMPLATE = (body && body.getAttribute('data-sugar-template')) || '';
  var PAGE = (body && body.getAttribute('data-gs-page')) || '';

  function isTemplate(name) {
    return TEMPLATE === name || TEMPLATE.indexOf(name + '.') === 0;
  }

  // Corre fn repetidamente ate devolver true, ou ate esgotar as tentativas.
  function retry(fn, tries, delay) {
    var n = 0;
    var iv = setInterval(function () {
      n++;
      if (fn() || n > (tries || 20)) clearInterval(iv);
    }, delay || 500);
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // Preenche um collapsible vazio da pagina de produto pelo titulo.
  function fillCollapsible(headingText, html) {
    var titles = document.querySelectorAll('.collapsible-row__title');
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i];
      if (t.textContent.replace(/\s+/g, ' ').trim() === headingText) {
        var row = t.closest('.collapsible-row');
        var inner = row ? row.querySelector('.collapsible-row__content-inner') : null;
        if (inner && inner.innerHTML.trim() === '') {
          inner.innerHTML = html;
          inner.classList.add('gs-fixed');
          return true;
        }
      }
    }
    return false;
  }


  /* ---------------------------------------------------------------
     1. Homepage - botoes do hero, imagens dos acessorios,
        links para as politicas nos paragrafos de garantias
     --------------------------------------------------------------- */
  function heroAndAccessories() {
    var done = true;

    var btns = [].filter.call(document.querySelectorAll('a,button'), function (e) {
      return e.textContent.trim().toUpperCase() === 'SHOP NOW';
    });

    function style(el, label, href, bg, fg, border) {
      el.textContent = label;
      if (el.tagName === 'A') el.setAttribute('href', href);
      el.classList.add('gs-hero-btn');
      el.style.setProperty('background', bg, 'important');
      el.style.setProperty('color', fg, 'important');
      el.style.setProperty('border', border, 'important');
    }

    if (btns[0]) style(btns[0], 'Ver os raros', '/collections/descontinuados', '#E00000', '#ffffff', '0');
    if (btns[1]) style(btns[1], 'Visitar a loja', '/pages/loja-fisica', '#ffffff', '#121212', '1px solid #121212');
    if (!document.querySelector('.gs-hero-btn')) done = false;

    var verTodas = [].find.call(document.querySelectorAll('a,button'), function (e) {
      return e.textContent.trim().indexOf('Ver todas as coleções') === 0;
    });
    if (verTodas) verTodas.classList.add('gs-hero-btn');

    [].forEach.call(document.querySelectorAll('a[class*="acessorios_btn"]'), function (e) {
      e.classList.add('gs-btn-cap');
    });

    if (!document.querySelector('.gs-acc-imgs')) {
      var headings = [].filter.call(document.querySelectorAll('h1,h2,h3'), function (e) {
        return e.textContent.indexOf('merece ser exposta') > -1;
      });
      if (headings.length) {
        var d = document.createElement('div');
        d.className = 'gs-acc-imgs';
        d.innerHTML =
          '<img src="https://cdn.shopify.com/s/files/1/0926/8074/9387/files/41.png?v=1775146743&width=840" alt="Vaso G Studs para Lego Botanicals" loading="lazy">' +
          '<img src="https://cdn.shopify.com/s/files/1/0926/8074/9387/files/1_fbc276fb-99a2-46a8-966c-a5936f355644.png?v=1770400827&width=840" alt="Suporte de parede G Studs para Speed Champions" loading="lazy">';
        var target = headings[0].closest('.custom-column') || headings[0].parentElement;
        target.insertBefore(d, target.firstChild);
      } else {
        done = false;
      }
    }

    // Acrescenta "Todos os detalhes <link>." aos paragrafos de garantias.
    function appendPolicyLink(match, href, label) {
      var ps = [].filter.call(document.querySelectorAll('p'), function (p) {
        return p.textContent.indexOf(match) > -1 && !p.classList.contains('gs-linked');
      });
      ps.forEach(function (p) {
        p.classList.add('gs-linked');
        var a = document.createElement('a');
        a.href = href;
        a.textContent = label;
        a.style.textDecoration = 'underline';
        a.style.color = 'inherit';
        p.appendChild(document.createTextNode(' Todos os detalhes '));
        p.appendChild(a);
        p.appendChild(document.createTextNode('.'));
      });
    }
    appendPolicyLink('portes são por nossa conta', '/policies/shipping-policy', 'na política de envios');
    appendPolicyLink('trocamos ou devolvemos até 14 dias', '/policies/refund-policy', 'na política de devoluções');
    appendPolicyLink('acertar é connosco, trocar é fácil', '/policies/refund-policy', 'na política de devoluções');

    return done;
  }


  /* ---------------------------------------------------------------
     2. Pagina de produto - descricao no collapsible, linha de stock,
        conteudo dos collapsibles de envios e levantamento
        (le os dados do #gs-pdp-data injetado no theme.liquid)
     --------------------------------------------------------------- */
  function productInfo() {
    var data = document.getElementById('gs-pdp-data');
    if (!data) return true;

    var qty = parseInt(data.getAttribute('data-qty') || '0', 10);
    var tracked = data.getAttribute('data-tracked');
    var policy = data.getAttribute('data-policy');
    var descB64 = data.getAttribute('data-desc');

    // Descricao: vem em base64 para sobreviver ao atributo HTML.
    if (descB64) {
      try {
        var bin = atob(descB64);
        var bytes = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        fillCollapsible('Descrição', new TextDecoder('utf-8').decode(bytes));
      } catch (e) {}
    }

    // Linha de stock por baixo do bloco de preco.
    var priceBlock = document.querySelector('.product-price-block');
    if (priceBlock && !document.querySelector('.gs-stock') && tracked === 'shopify') {
      var cls = 'gs-stock ';
      var text = '';
      if (qty > 0 && qty <= 10) {
        cls += 'gs-stock--low';
        text = 'Poucas unidades disponíveis — ' + (qty === 1 ? 'resta' : 'restam') + ' <strong>' + qty + '</strong>';
      } else if (qty > 0) {
        cls += 'gs-stock--in';
        text = '<strong>' + qty + '</strong> em stock';
      } else if (policy === 'continue') {
        cls += 'gs-stock--in';
        text = 'Disponível por encomenda';
      } else {
        cls += 'gs-stock--out';
        text = 'Esgotado';
      }
      var line = document.createElement('div');
      line.className = cls;
      line.innerHTML = '<span class="gs-stock__dot"></span><span>' + text + '</span>';
      priceBlock.parentElement.insertBefore(line, priceBlock.nextSibling);
    }

    fillCollapsible(
      'Envios & Devoluções',
      '<p>Envio em 24-48h úteis (grátis acima de 100€). Trocas e devoluções até 14 dias. Ver <a href="/policies/shipping-policy">política de envios</a> e <a href="/policies/refund-policy">devoluções</a>.</p>'
    );
    fillCollapsible(
      'Levantamento em loja',
      '<p>Grátis, na Estrada da Luz 136A (Lisboa). Normalmente pronto em 1 hora. Ter-Sex 15h-19h · Sáb 10h-13h e 15h-19h.</p>'
    );

    return true;
  }


  /* ---------------------------------------------------------------
     3. Pagina de produto - preco dentro do botao "Adicionar ao carrinho"
     --------------------------------------------------------------- */
  function addToCartPrice() {
    var data = document.getElementById('gs-pdp-data');
    if (!data) return true;

    var price = data.getAttribute('data-price');
    var compare = data.getAttribute('data-compare');
    if (!price) return true;

    var btn = null;
    var sels = ['.product-form__submit', 'button[name="add"]', 'form[action*="/cart/add"] button[type="submit"]'];
    for (var i = 0; i < sels.length && !btn; i++) btn = document.querySelector(sels[i]);
    if (!btn) return false;

    var html = '';
    if (compare) html += '<span class="gs-atc-price__old">' + compare + '</span>';
    html += '<span class="gs-atc-price__now">' + price + '</span>';

    var span = btn.querySelector('.gs-atc-price');
    if (span) {
      if (span.innerHTML !== html) span.innerHTML = html;
      return true;
    }
    span = document.createElement('span');
    span.className = 'gs-atc-price';
    span.innerHTML = html;
    btn.appendChild(span);
    return true;
  }


  /* ---------------------------------------------------------------
     4. Cart drawer - singular/plural correto na contagem
     --------------------------------------------------------------- */
  function cartCountPlural() {
    var counts = document.querySelectorAll('.sugar-cart-header__count');
    for (var i = 0; i < counts.length; i++) {
      var c = parseInt((counts[i].textContent || '').trim(), 10);
      if (isNaN(c)) continue;
      var node = counts[i].nextSibling;
      while (node) {
        if (node.nodeType === 3 && /produto/i.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(/produtos?/i, c === 1 ? 'produto' : 'produtos');
          break;
        }
        node = node.nextSibling;
      }
    }
  }


  /* ---------------------------------------------------------------
     5. Cart drawer - titulos dos selos encurtados
     --------------------------------------------------------------- */
  var SEAL_LABELS = { 'Produtos 100% Originais': '100% Original', 'Envios 24-48h': '24-48h' };
  function shortenSealHeadings() {
    var hs = document.querySelectorAll('.sugar-cart-drawer__footer .icon-heading-list__heading');
    for (var i = 0; i < hs.length; i++) {
      var t = hs[i].textContent.trim();
      if (SEAL_LABELS[t]) hs[i].textContent = SEAL_LABELS[t];
    }
  }


  /* ---------------------------------------------------------------
     6. Lista de colecoes - pills de filtro por categoria
     --------------------------------------------------------------- */
  var COLLECTION_CATEGORY = {
    'acessorios-g-studs': 'acessorios',
    'suportes-e-acessorios-de-exposicao-para-sets-minifiguras-lego': 'acessorios',
    'suportes-e-acessorios-de-exposicao-para-sets-minifiguras-lego®': 'acessorios',
    'vasos-para-as-flores-lego-botanicals': 'acessorios',
    descontinuados: 'raros',
    'sets-usados': 'raros',
    'panini-cromos-mundial-2026-world-cup': 'cromos'
  };
  var PILLS = [
    ['todas', 'Todas'],
    ['temas', 'Temas'],
    ['acessorios', 'Acessórios'],
    ['raros', 'Raros & Usados'],
    ['cromos', 'Cromos']
  ];

  function categoryFor(handle) {
    if (COLLECTION_CATEGORY[handle]) return COLLECTION_CATEGORY[handle];
    // Fallback: alguns handles antigos tinham ® ou acentos; normaliza e tenta de novo.
    var n = handle.replace(/[^a-z0-9-]/g, '').replace(/-+$/, '');
    return COLLECTION_CATEGORY[n] || 'temas';
  }

  function handleOfCard(card) {
    var a = card.querySelector('a[href*="/collections/"]');
    if (!a) return '';
    var m = (a.getAttribute('href') || '').match(/\/collections\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }

  function findGrid(cards) {
    var el = cards[0];
    while (el && el.parentElement) {
      var p = el.parentElement;
      var n = 0;
      for (var i = 0; i < p.children.length; i++) {
        var c = p.children[i];
        if (c.matches && (c.matches('.collections-list-card') || c.querySelector('.collections-list-card'))) n++;
      }
      if (n > 1) return p;
      el = p;
    }
    return null;
  }

  function buildCategoryPills() {
    var cards = document.querySelectorAll('.collections-list-card');
    if (!cards.length) return false;
    if (document.querySelector('.gs-cat-pills')) return true;

    var grid = findGrid(cards);
    if (!grid) return false;

    var items = [];
    for (var i = 0; i < grid.children.length; i++) {
      var it = grid.children[i];
      var card = it.matches('.collections-list-card') ? it : it.querySelector('.collections-list-card');
      if (!card) continue;
      it.setAttribute('data-gs-cat', categoryFor(handleOfCard(card)));
      items.push(it);
    }

    var present = {};
    items.forEach(function (it) {
      present[it.getAttribute('data-gs-cat')] = true;
    });

    var bar = document.createElement('div');
    bar.className = 'gs-cat-pills';
    PILLS.forEach(function (p) {
      if (p[0] !== 'todas' && !present[p[0]]) return;
      var b = document.createElement('button');
      b.className = 'gs-cat-pill' + (p[0] === 'todas' ? ' is-active' : '');
      b.type = 'button';
      b.textContent = p[1];
      b.setAttribute('data-cat', p[0]);
      b.addEventListener('click', function () {
        [].forEach.call(bar.querySelectorAll('.gs-cat-pill'), function (x) {
          x.classList.toggle('is-active', x === b);
        });
        items.forEach(function (it) {
          it.style.display = p[0] === 'todas' || it.getAttribute('data-gs-cat') === p[0] ? '' : 'none';
        });
      });
      bar.appendChild(b);
    });

    grid.parentElement.insertBefore(bar, grid);
    return true;
  }


  /* ---------------------------------------------------------------
     7. Pagina Sobre Nos - bio reescrita
     --------------------------------------------------------------- */
  function bioHtml() {
    return (
      '<p>Tenho 24 anos e uma <strong>paixão séria</strong> por Lego — aquela que começa em criança, não desaparece em adulto, e acaba por se transformar num negócio.</p>' +
      '<p>Foi exatamente o que aconteceu com a G Studs.</p>' +
      '<p>Como colecionador, conheço a frustração de procurar aquele set que já saiu das lojas — e o receio de o comprar online sem saber se chega original e selado.</p>' +
      '<p>Criei a G Studs para ser o sítio onde eu próprio gostaria de comprar: <strong>sets raros, atuais e descontinuados, todos 100% originais e selados</strong>, com quem percebe mesmo de Lego do outro lado.</p>' +
      '<p><strong>Somos +5.000 colecionadores. Bem-vindo.</strong></p>'
    );
  }

  function replaceBio() {
    if (document.querySelector('.gs-bio-fixed')) return true;

    var ps = document.querySelectorAll('p');
    var p1 = null;
    for (var i = 0; i < ps.length; i++) {
      if (ps[i].textContent.indexOf('Tenho 24 anos') > -1) {
        p1 = ps[i];
        break;
      }
    }
    if (!p1) return false;

    var parent = p1.parentElement;
    if (parent.textContent.indexOf('Foi exatamente') > -1) {
      parent.innerHTML = bioHtml();
      parent.classList.add('gs-bio-fixed');
    } else {
      var p2 = null;
      for (var j = 0; j < ps.length; j++) {
        if (ps[j].textContent.indexOf('Foi exatamente') > -1) {
          p2 = ps[j];
          break;
        }
      }
      var d = document.createElement('div');
      d.className = 'gs-bio-fixed';
      d.innerHTML = bioHtml();
      p1.parentElement.insertBefore(d, p1);
      p1.remove();
      if (p2) p2.remove();
    }
    return true;
  }


  /* ---------------------------------------------------------------
     Arranque - cada modulo so na pagina onde faz sentido
     --------------------------------------------------------------- */

  // Homepage (e qualquer pagina onde o hero apareca).
  retry(heroAndAccessories, 20, 500);

  // Pagina de produto.
  if (isTemplate('product')) {
    retry(productInfo, 20, 500);
    retry(addToCartPrice, 20, 400);
    document.addEventListener('click', function () {
      setTimeout(addToCartPrice, 400);
    });
  }

  // Lista de colecoes.
  if (isTemplate('list-collections')) {
    retry(buildCategoryPills, 20, 400);
  }

  // Pagina Sobre Nos.
  if (PAGE === 'sobre_nos') {
    retry(replaceBio, 20, 400);
  }

  // Cart drawer - presente em todas as paginas, monta e desmonta a qualquer momento.
  function refreshCart() {
    cartCountPlural();
    shortenSealHeadings();
  }
  setInterval(refreshCart, 700);
  document.addEventListener('click', function () {
    setTimeout(refreshCart, 300);
  });
  if (document.readyState !== 'loading') {
    refreshCart();
  } else {
    document.addEventListener('DOMContentLoaded', refreshCart);
  }
})();
